/**
 * Copyright (c) 2025-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Apache License 2.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const NotificationLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="M22 20H2v-2h1v-6.97A9 9 0 0 1 12 2c4.97 0 9 4.04 9 9.03V18h1zM5 18h14v-6.97A7 7 0 0 0 12 4c-3.87 0-7 3.15-7 7.03zm4.5 3h5a2.5 2.5 0 0 1-5 0" />
  </Icon>
);
